/**
 * Global / Legacy: Sections
 * ------------------------------------------------------------------------------
 * Main entrypoint to import legacy Shopify sections
 * - During the original re-platform project, JSON-based Shopify sections were
 *   not used, which lead to sections' JS file being imported on every page.
 * - This file exists to separate these imports from the main app.js.
 */
import '@/global/legacy.sections.scss'

import ShopTheLookPopup from '~/components/shop-the-look-popup'

import HeroHotSpot from '~/sections/hero-hotspot'
import SearchModalInit from '~/components/vue/search-render'
import VideoHalfWidth from '~/sections/video-half-width'

/**
 * DOM is ready.
 */
document.addEventListener('DOMContentLoaded', () => {

  /**
   * Node based components.
   */
  VideoHalfWidth.init()
})

window.addEventListener('load', () => {
  HeroHotSpot.init()
  ShopTheLookPopup.init()
})
